module.exports = __webpack_public_path__ + "static/media/slideshow (2).09fbf259.png";